<template>
  <header class="col-start-1 col-end-13 row-start-2 row-end-3 rounded-br-xl xl:rounded-br-full bg-secondary-gray">
    <div class="grid grid-cols-columns">
      <div class="col-start-2 col-end-12">
        <div
          class="header-wrapper container mx-auto pb-24 xxl:pb-32 xxl:px-6 lg:grid lg:grid-cols-12 lg:gap-8 items-center"
        >
          <page-header-title @scrollTo="scrollTo"/>
          <page-header-items />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { gsap } from "gsap";
import PageHeaderTitle from "@/components/header/PageHeaderTitle";
import PageHeaderItems from "@/components/header/PageHeaderItems";

export default {
  name: "PageHeader",
  components: {
    PageHeaderTitle,
    PageHeaderItems,
  },
  methods: {
    scrollTo(containerRef) {
      this.$emit('scrollTo', containerRef)
    }
  },
  mounted() {
    this.$nextTick(() => {
      gsap.set(".header-wrapper", { autoAlpha: 1 });
    });
  },
};
</script>

<style scoped>
.header-wrapper {
  visibility: hidden;
}
</style>
